/**
 * ECUCInterfaces.tsx
 * This file defines TypeScript interfaces for the ECUC catalog selection object.
 * It includes interfaces for the structure of the catalog selection, items, and options.
 */
export interface ECUCataSelectObjectInterface {
    programs: ECUCataSelectProgramItemInterface;
    module: ECUCataSelectSingleItemInterface;
    machines: ECUCataSelectItemInterface;
    variants: ECUCataSelectVariantItemInterface;
    error: boolean;
    errorMessage?: string; // Optional, if it can be undefined
}


export interface ECUCataSelectOptionInterface {
    label: string;
    value: any
};

export interface ECUCataSelectProgramOptionInterface extends ECUCataSelectOptionInterface {
    electricalArchitecture?: string;
}

export interface ECUCataSelectProgramItemInterface {
    unfilteredOptions: ECUCataSelectProgramOptionInterface[]; // All options before filtering
    options: ECUCataSelectProgramOptionInterface[];
    value: ECUCataSelectProgramOptionInterface[];
}

export interface ECUCataSelectItemInterface {
    options: ECUCataSelectOptionInterface[];
    value: ECUCataSelectOptionInterface[];
}


export interface ECUCataSelectVariantItemInterface {
    options: ECUCataSelectOptionVariantInterface[];
    value: ECUCataSelectOptionVariantInterface[];
}

export interface ECUCataSelectSingleItemInterface {
    options: ECUCataSelectOptionInterface[];
    value: ECUCataSelectOptionInterface | null; // Single item, so value can be null
}

export interface ECUCataSelectOptionClusterInterface {
        label: string;
        value: any; // Can be string, number, or boolean
        variantId: string | number; 
        machineId: string | number; 
};


export const ecucCataSelectObjTemplate: ECUCataSelectObjectInterface = {
        programs:{
           value:[],
           options:[],
           unfilteredOptions: []
        },
        module:{
           value: null,
           options:[]
        },
        machines:{
           value: [],
           options:[]
        },
        variants:{
           value: [],
           options:[]
        },
        error: false,
        errorMessage: "",
}

export const ECUCataSelectOptionTemplate: ECUCataSelectOptionInterface = {
    label: "",
    value: ""
} 


export interface ECUCataSelectOptionVariantInterface {
    value: any
    label: string;
    machineId: string | number
}